import { PixKey } from './key.model';
import { TipoIniciacaoTransferencia } from './tipo-iniciacao-transacao.enum';

export class PixQrCodeReturn {
	tipo: string;
	valor: number;
	desconto: number;
	multa: number;
	juros: number;
	original: number;
	abatimento: number;
	conta: PixQrCodeReturnConta; // DESTINATARIO
	codigoTransacao: string;
	chavePix: PixKey;
	codigoFimAFim: string;
	descricao: string;
	qrCodeDinamico: PixQrCodeReturnQrCodeDinamico;
	tipoIniciacaoTransacao: TipoIniciacaoTransferencia;
}
export interface PixQrCodeReturnConta {
	numeroConta: string;
	tipoConta: string;
	numeroAgencia: number;
	documento: string;
	iSPBCodigo: string;
	iSPBNome: string;
	nome: string;
}

export interface PixQrCodeReturnInformacaoAdicional {
	nome: string;
	valor: string;
}

export interface PixQrCodeReturnCalendario {
	dataCriacao: string;
	dataVencimento: string;
	dataExpiracao: string;
	expiracaoEmSegundos: number;
	dataApresentacao: string;
	diasValidadeAposVencimento: number;
}

export interface PixQrCodeReturnDevedor {
	documento: string;
	nome: string;
}

export interface PixQrCodeReturnRecebedor {
	endereco: string;
	nomeFantasia: string;
	cidade: string;
	documento: string;
	nome: string;
	uF: string;
	cEP: string;
}
export interface PixQrCodeReturnValores {
	desconto: number;
	multa: number;
	juros: number;
	original: number;
	abatimento: number;
}

export interface PixQrCodeReturnQrCodeDinamico {
	informacaoAdicional: PixQrCodeReturnInformacaoAdicional[];
	calendario: PixQrCodeReturnCalendario;
	tipoCobranca: string;
	devedor: PixQrCodeReturnDevedor;
	recebedor: PixQrCodeReturnRecebedor;
	revisao: number;
	situacao: string;
	valores: PixQrCodeReturnValores;
	mensagem: string;
	pagamento: QrCodeDinamicoPagamentoModel ;
	tipoOperacao: ETipoOperacao;
	troco?: QrCodeDinamicoTrocoModel;
	saque?: QrCodeDinamicoSaqueModel;
}

export enum ETipoOperacao{
	PAGAMENTO = 'PAGAMENTO',
	SAQUE = 'SAQUE',
	TROCO = 'TROCO'
}

export class QrCodeDinamicoPagamentoModel {
	troca: number
	desconto: number
	taxa: number
	modalidadeTroca: string;
	abatimento: string;
	multa: string;
}
export class QrCodeDinamicoSaqueModel {
	ispbServico: string;
	modalidadeTroca: string;
	tipoAgente: ETipoAgenteSaquetroco
}

export class QrCodeDinamicoTrocoModel {
	compra: number;
	troca: number;
	ispbServico: string;
	modalidadeTroca: string;
	tipoAgente: ETipoAgenteSaquetroco
}

export enum ETipoAgenteSaquetroco{
	PRESTADOR_DE_SERVICO_DE_SAQUE = 'PRESTADOR_DE_SERVICO_DE_SAQUE',
	ESTABELECIMENTO_COMERCIAL = 'ESTABELECIMENTO_COMERCIAL',
	OUTRA_ESPECIE_DE_PESSOA_JURIDICA = 'OUTRA_ESPECIE_DE_PESSOA_JURIDICA'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/qr-code-return.model.ts